import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Container, Divider, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

export const PageShell = styled(Box)({
  minHeight: '100vh', background: '#fff', paddingTop: '82px',
  '@media (max-width: 1000px)': { paddingTop: '12px' },
});

export const DashboardContainer = styled(Container)(({ theme }) => ({
  display: 'grid', gridTemplateColumns: '196px minmax(0, 1fr)', gap: '28px', paddingBottom: '28px',
  [theme.breakpoints.down('md')]: { gridTemplateColumns: '1fr', gap: '12px' },
}));

const SidebarCard = styled(Paper)(({ theme }) => ({
  position: 'sticky', top: '88px', alignSelf: 'start', borderRadius: 0,
  padding: '8px 0', background: 'transparent', boxShadow: 'none',
  '@media (max-width: 1000px)': { top: '12px' },
  [theme.breakpoints.down('md')]: {
    position: 'static', display: 'flex', flexWrap: 'wrap', gap: '4px',
    '& > .MuiTypography-root': { display: 'none' },
    '& > .MuiBox-root': { display: 'contents' },
    '& .MuiDivider-root': { display: 'none' },
    '& .MuiButton-root': { width: 'auto', margin: 0, fontSize: '12px', padding: '8px' },
    '& .MuiButton-startIcon': { display: 'none' },
  },
}));

const NavButton = styled(Button, {
  shouldForwardProp: prop => prop !== 'active',
})(({ active }) => ({
  justifyContent: 'flex-start', width: '100%', borderRadius: '6px',
  padding: '9px 11px', marginBottom: '6px', textTransform: 'none',
  fontSize: '0.9rem', fontWeight: 600, color: active ? '#fff' : '#575c68',
  background: active ? '#8250df' : 'transparent', boxShadow: 'none',
  '&:hover': { background: active ? '#7040c7' : '#f3effa' },
}));

export default function IELTSWorkspaceSidebar({ activeView, isSubscribed = true, onViewChange }) {
  const navigate = useNavigate();
  const changeView = view => onViewChange ? onViewChange(view) : navigate(`/ielts-dashboard?view=${view}`);
  return <SidebarCard component="nav" aria-label="IELTS navigation">
    <Typography sx={{ px: 1.4, mb: 2, fontSize: 12, fontWeight: 700, color: '#777b86' }}>IELTS WORKSPACE</Typography>
    <NavButton startIcon={<DashboardOutlinedIcon />} active={activeView === 'dashboard'} onClick={() => changeView('dashboard')}>Dashboard</NavButton>
    <NavButton startIcon={<AssignmentOutlinedIcon />} active={activeView === 'planner'} onClick={() => navigate('/ielts/study-planner')}>AI Study Planner</NavButton>
    <Box data-tour="ielts-dashboard-navigation-actions">
      <NavButton startIcon={<AssessmentOutlinedIcon />} active={activeView === 'results'} onClick={() => changeView('results')}>Results</NavButton>
      <Divider sx={{ my: 1 }} />
      <NavButton startIcon={<MenuBookOutlinedIcon />} active={activeView === 'sectional'} onClick={() => changeView('sectional')}>Sectional Mock Test</NavButton>
      <NavButton startIcon={<MenuBookOutlinedIcon />} active={activeView === 'mini'} aria-current={activeView === 'mini' ? 'page' : undefined} onClick={() => navigate('/ielts-mini-exercises')}>
        Mini Exercises {!isSubscribed && <LockOutlinedIcon sx={{ ml: 1, fontSize: 16 }} />}
      </NavButton>
      <NavButton startIcon={<AssignmentOutlinedIcon />} active={activeView === 'full'} onClick={() => changeView('full')}>Full Mock Test</NavButton>
    </Box>
  </SidebarCard>;
}
